import React from 'react';

type Theme = 'light' | 'dark';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = React.createContext<ThemeContextType>({
  theme: 'light',
  toggleTheme: () => {},
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = React.useState<Theme>(() => {
    // Always default to light mode
    return 'light';
    
    // Original code preserved but commented out:
    // if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //   return 'dark';
    // }
    // const savedTheme = localStorage.getItem('theme');
    // return (savedTheme as Theme) || 'light';
  });

  React.useEffect(() => {
    // Always remove the dark class to ensure light mode
    document.documentElement.classList.remove('dark');
    
    // Original code preserved but will only add the class if theme is dark (which we've disabled)
    document.documentElement.classList.toggle('dark', theme === 'dark');
    
    // Still save the preference to maintain functionality
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    // Function remains intact but the dark theme won't apply visually
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => {
  const context = React.useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};